import React from 'react';

export default function TypificationSelect(props) {
  console.log('TypificationSelect', props);

  if(props.typification[0] == null){
    return (
      <select className="form-control form-control-sm" name="typification" required={true} defaultValue="" ref={props.typificationRef}>
        <option value="">No hay categorías disponibles</option>
      </select>
    );
  }

  const renderTypificationOption = (typification) => (
    <option key={typification.id} value={typification.id}>
       {typification.ReplyType} - {typification.typificationText}
    </option>
  );

  const typifications = props.typification || [];

  return (
    <select className="form-control form-control-sm" name="typification" required={true} defaultValue="" ref={props.typificationRef}>
      <option value="">Selecciona una typification</option>
      {typifications.map(renderTypificationOption)}
    </select>
  );
}
